import { create } from "../../../common/utils/zustand_state_manager";
import { IProjetosService } from "../../../features/projetos/data/services/projetos_service";
import { ProjetosService } from "../../../features/projetos/data/services/projetos_service_impl";

/**
 * useObrasServices
 */

type State = {
  projetosService: IProjetosService;
};

export const useProjetosServices = create<State>((set, get) => ({
  projetosService: new ProjetosService(),
}));
